module.exports = __webpack_public_path__ + "img/thank8.50f41a89.gif";